module.exports = __webpack_public_path__ + "img/m-hd.db778736.webp";